export default "__VITE_ASSET__6641ce20__"